import { render, staticRenderFns } from "./BotGenerate.vue?vue&type=template&id=eb4f0ab6&"
import script from "./BotGenerate.vue?vue&type=script&lang=js&"
export * from "./BotGenerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports